const MainInformationTypes = {
  RESET_PAGE_EDITION : "RESET_PAGE_EDITION",
  SET_PAGE_EDITION : "SET_PAGE_EDITION",
  CHECK_PASSWORD : "CHECK_PASSWORD",
  SET_CHECK_PASSWORD_RESULT: "SET_CHECK_PASSWORD_RESULT",
  SET_PASSWORD_IS_CHECKED: "SET_PASSWORD_IS_CHECKED",
  CHANGE_WIDGET_CONDITION_EDITION_STATUS: "CHANGE_WIDGET_CONDITION_EDITION_STATUS",
  SET_CONTROL_EDITION: "SET_CONTROL_EDITION",
  RESET_CONTROL_EDITION: "RESET_CONTROL_EDITION",
}

export default MainInformationTypes